import Axios from "axios"
import toastr from "toastr"

export const requestTemplateSection = async ({ payload }) => {
  const offset = payload.filters["currentPage"]
    ? payload.filters["currentPage"] - 1
    : 0
  const limit = payload.filters["pageSize"]
  try {
    let data = await Axios.get(
      `/api/template-section/getdata?sectionId=${payload.filters.sectionId}&sectionName=${payload.filters.sectionName}&isActive=${payload.filters.isActive}&offset=${offset}&limit=${limit}`
    )
    return data
  } catch (error) {
    throw error
  }
}

export const requestUpsertTemplateSection = async ({ payload }) => {
  try {
    const url = `/api/template-section/upsert?action=${payload.action}`
    let response = await Axios.post(url, payload.data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    toastr.success("Action Successfull !!")
    return response
  } catch (error) {
    toastr.error(error)
    return error
  }
}

export const requestReorderTemplateSection = async ({ payload }) => {
  try {
    const url = `/api/template-section/reorder`
    let response = await Axios.post(url, payload)
    toastr.success("Action Successfull !!")
    return response
  } catch (error) {
    toastr.error(error)
    return error
  }
}

export const requestAddTemplate = async ({ payload }) => {
  try {
    const url = `/api/template-section/template-mapping`
    let response = await Axios.post(url, payload)
    toastr.success("Action Successfull !!")
    return response
  } catch (error) {
    toastr.error(error)
    return error
  }
}

export const requestUpdateVersion = async ({ payload }) => {
  try {
    const url = `/api/template-section/update-version`
    let response = await Axios.post(url, payload)
    toastr.success("Action Successfull !!")
    return response
  } catch (error) {
    toastr.error(error)
    return error
  }
}
